// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconChevronLeft } from "../components/icons.jsx";
import { IconCalendar } from "../components/icons.jsx";
import { IconUsers } from "../components/icons.jsx";
import { IconUsersGroup } from "../components/icons.jsx";
import { IconMedal } from "../components/icons.jsx";
export const Bg = "_page_793be_1";
export const Ug = "_header_793be_2";
export const Hg = "_back_793be_3";
export const Lg = "_content_793be_6";
export const qg = "_hero_793be_7";
export const Gg = "_grid_793be_7";
export const Yg = "_row_793be_7";
export const Xg = "_date_793be_12";
export const Ra = {
  page: Bg,
  header: Ug,
  back: Hg,
  content: Lg,
  hero: qg,
  grid: Gg,
  row: Yg,
  date: Xg
};
export const Qi = u => (u ?? 0).toLocaleString("ru-RU");
export function parseRegistrationDate(u) {
  const o = u?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!o) return null;
  const m = Number(o[1]),
    r = Number(o[2]),
    g = Number(o[3]),
    j = Date.UTC(m, r - 1, g),
    B = new Date(j);
  if (B.getUTCFullYear() !== m || B.getUTCMonth() !== r - 1 || B.getUTCDate() !== g) return null;
  const U = new Date(),
    N = Date.UTC(U.getUTCFullYear(), U.getUTCMonth(), U.getUTCDate());
  return {
    date: B.toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC"
    }),
    days: Math.max(0, Math.floor((N - j) / 864e5))
  };
}
export function StatisticsPage({
  meta: u,
  onBack: o
}) {
  const m = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (window.scrollTo(0, 0), !!m) return m.show(), m.onClick(o), () => {
      m.offClick(o), m.hide();
    };
  }, [m, o]);
  const r = parseRegistrationDate(u.joinedAt),
    g = u.referral?.total ?? 0;
  return jsxRuntime.jsxs("section", {
    className: Ra.page,
    "aria-labelledby": "statistics-title",
    children: [jsxRuntime.jsxs("header", {
      className: Ra.header,
      children: [jsxRuntime.jsx("button", {
        type: "button",
        className: `${Ra.back} mc-icon-button`,
        onClick: o,
        "aria-label": "Назад к профилю",
        children: jsxRuntime.jsx(IconChevronLeft, {})
      }), jsxRuntime.jsx("h1", {
        id: "statistics-title",
        children: "Статистика"
      })]
    }), jsxRuntime.jsxs("div", {
      className: Ra.content,
      children: [jsxRuntime.jsxs("article", {
        className: Ra.hero,
        children: [jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx(IconCalendar, {}), " С нами с"]
        }), jsxRuntime.jsx("strong", {
          className: Ra.date,
          children: r?.date ?? "Дата неизвестна"
        }), jsxRuntime.jsx("p", {
          children: r ? `${Qi(r.days)} дней в MetaCard` : "Дата регистрации пока недоступна"
        })]
      }), jsxRuntime.jsxs("div", {
        className: Ra.grid,
        children: [jsxRuntime.jsxs("article", {
          children: [jsxRuntime.jsx(IconUsers, {}), jsxRuntime.jsx("strong", {
            children: Qi(u.friends)
          }), jsxRuntime.jsx("span", {
            children: "Друзей"
          })]
        }), jsxRuntime.jsxs("article", {
          children: [jsxRuntime.jsx(IconUsersGroup, {}), jsxRuntime.jsx("strong", {
            children: Qi(g)
          }), jsxRuntime.jsx("span", {
            children: "Приглашено"
          })]
        })]
      }), jsxRuntime.jsxs("article", {
        className: Ra.row,
        children: [jsxRuntime.jsx("span", {
          children: "Активных приглашений"
        }), jsxRuntime.jsx("strong", {
          children: Qi(u.referral?.active)
        })]
      }), jsxRuntime.jsxs("article", {
        className: Ra.row,
        children: [jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx(IconMedal, {}), " Годовой бейдж"]
        }), jsxRuntime.jsx("strong", {
          children: u.registrationBadge ? `${u.registrationBadge} ${u.registrationBadge === 1 ? "год" : "года"}` : "Пока нет"
        })]
      })]
    })]
  });
}
